const component = require('../component/component');

const file = Object.assign({}, component, {
    subelements: {
        displayHolder: false,
        alreadyAction: false,
        already: false,
        temp: false,
        fileHolder: false,
        change: null,
        remove: null,
        revert: null,
        hidden: false
    },
    validationTriggeringEvents: ['change'],

    init: function () {
        component.init.call(this);

        if (this.initialValue) {
            this.showSub('displayHolder');
            this.showSub('already');
            this.showSub('change');
            this.showSub('remove');
        } else {
            this.showSub('temp');
            this.showSub('fileHolder');
        }

        this.element.addEventListener('change', () => { this.inputChanged(); });

        if (this.hasSubelement('change')) {
            this.subelements.change.onclick = () => { this.removeCurrentFile(false); };
        }

        if (this.hasSubelement('remove')) {
            this.subelements.remove.onclick = () => { this.removeServerFile(); };
        }

        if (this.hasSubelement('revert')) {
            this.subelements.revert.onclick = () => { this.revert(); };
        }
    },

    inputChanged: function () {
        if (this.element.value) {
            this.showSub('displayHolder');
            this.hideSub('fileHolder');
            this.showSub('already', this.initialValue !== '');
            if (this.initialValue !== '') {
                this.subelements.alreadyAction.innerHTML = this.hm.app.utext('removingCurrentFile') + ': ';
            }

            let filePath = this.element.value;
            let fileName = filePath;
            if (filePath.lastIndexOf('/') != -1)
                fileName = filePath.substr(filePath.lastIndexOf('/') + 1);
            else if (filePath.lastIndexOf('\\') != -1)
                fileName = filePath.substr(filePath.lastIndexOf('\\') + 1);

            this.subelements.temp.innerHTML = this.hm.app.utext('newFileToUpload') + ': ' + fileName;
            this.showSub('temp');
        }

        this.showSub('change');
        this.hideSub('remove');
        this.showSub('revert');
    },

    removeServerFile: function () {
        let deleteText = this.hm.app.utext('areYouSureDeleteFile');
        let consequence = () => { this.removeCurrentFile(true); };

        this.hm.app.confirmCall(deleteText, consequence);
    },

    revert: function () {
        let revertText = this.hm.app.utext('areYouSureRevertFile');
        let consequence = () => { this.reset(); };

        this.hm.app.confirmCall(revertText, consequence);
    },

    removeCurrentFile: function (removeServerFile) {
        if (removeServerFile === undefined) {
            removeServerFile = true;
        }

        this.subelements.temp.innerHTML = '';
        this.hideSub('temp');

        this.showSub('fileHolder');
        if (this.initialValue) {
            this.showSub('displayHolder');
            if (removeServerFile) {
                this.subelements.alreadyAction.innerHTML = this.hm.app.utext('removingCurrentFile') + ': ';
            } else {
                this.subelements.alreadyAction.innerHTML = this.hm.app.utext('maintainingCurrentFile') + ': ';
            }
            this.showSub('revert');
        } else {

            this.hideSub('displayHolder');
            this.hideSub('revert');
        }
        this.hideSub('change');
        this.hideSub('remove');
        this.element.value = '';

        if (removeServerFile) {
            this.subelements.hidden.value = '1';
        }
    },

    reset: function () {
        this.element.value = '';
        this.subelements.temp.innerHTML = '';
        this.hideSub('temp');
        this.hideSub('revert');

        if (this.subelements.hidden !== false && this.subelements.hidden.value === '1') {
            this.subelements.hidden = '0';
        }

        this.showSub('displayHolder', this.initialValue !== '');
        this.showSub('already', this.initialValue !== '');
        if (this.initialValue !== '') {
            this.subelements.alreadyAction.innerHTML = this.hm.app.utext('maintainingCurrentFile') + ': ';
        }
        this.showSub('fileHolder', this.initialValue === '');
        this.showSub('change', this.initialValue !== '');
        this.showSub('remove', this.initialValue !== '');
    },

    getValue: function () {
        return '';
    }
});

module.exports = file;